/*
 * Mobile app header Messages
 *
 * This contains all the text for the Mobile app header component.
 */
import { defineMessages } from 'react-intl';

export const mobileHeaderScope = 'mobileHeader';

export const mobileHeaderMessages = {
  myOrders: {
    id: `${mobileHeaderScope}.myOrders`,
    defaultMessage: 'Mes billets',
    en: 'My orders',
    it: 'I miei biglietti',
    es: 'Mis entradas',
    de: 'Meine Tickets',
    nl: 'Mijn tickets',
  },
  search: {
    id: `${mobileHeaderScope}.search`,
    defaultMessage: 'Recherche',
    en: 'Search',
    it: 'Ricerca',
    es: 'Busque',
    de: 'Suche',
    nl: 'Zoeken',
  },
};

export default defineMessages(mobileHeaderMessages);
